<div class="reject-modal">
  <!-- Header: X -->
  <button type="button" class="btn-close" (click)="close()">
    <i class="bi bi-x-lg"></i>
  </button>

  <!-- Icon + title -->
  <div class="reject-header">
    <i class="bi bi-exclamation-triangle-fill" style="color:#1945BF; font-size:2rem;"></i>

    <h2 class="reject-title">¿Estás seguro de que deseas rechazar el camión?</h2>
  </div>

  <!-- Body -->
  <div class="reject-body">
    <!-- Motivo -->
    <label class="field-label">Motivo de rechazo</label>

    <!-- ✅ SELECT (single) -->
    <div class="select-wrapper">
      <div class="select-input" [class.open]="isSelectOpen" (click)="openSelect()">
        <span class="select-placeholder" [class.is-placeholder]="!selectedRejectReason?.description">
          {{ selectedRejectReason?.description || 'Ingresa' }}
        </span>

        <i class="bi select-chevron" [ngClass]="isSelectOpen ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
      </div>

      <!-- Dropdown -->
      <div *ngIf="isSelectOpen" class="select-dropdown">
        <div class="dropdown-item" *ngFor="let rejectReason of rejectReasons"
          (click)="selectReason(rejectReason); $event.stopPropagation()">
          <span class="dropdown-text" [class.selected]="isSelected(rejectReason)">
            {{ rejectReason.description }}
          </span>
        </div>
      </div>
    </div>

    <!-- Observaciones -->
    <label class="field-label mt-14">Observaciones de rechazo</label>
    <textarea class="text-area" placeholder="Ingresa tu comentario"
      [formControl]="rejectForm.controls.rejectObservations"></textarea>

    <!-- Upload -->
    <label class="field-label mt-14">Adjuntar archivo</label>

    <input type="file" #fileInput (change)="onFileSelected($event)" multiple accept=".jpg,.jpeg,.png,.gif"
      style="display: none" />

    <!-- ✅ Estado: SIN archivo -->
    <div class="dropzone" *ngIf="!images.length">
      <div class="dropzone-left">
        <i class="bi bi-cloud-upload" style="font-size:1.5rem;"></i>
        <div class="dropzone-texts">
          <div class="dz-title">Importar archivo (png, jpg, gif)</div>
          <div class="dz-sub">El archivo no debe tener más de 500 MB</div>
        </div>
      </div>

      <button type="button" class="btn-outline" (click)="openFileSelector(); $event.stopPropagation()">
        Seleccionar archivo
      </button>
    </div>

    <!-- ✅ Estado: CON archivo(s) -->
    <div class="dropzone dropzone--filled" *ngIf="images.length">
      <!-- <div class="file-trash-mobile container-mobile">
        <button type="button" class="file-trash " (click)="removeImage(image)">
          <img src="assets/images/icons/delete.svg" class="delete" alt="delete" />
        </button>
      </div> -->

      <!-- <div></div> -->
      <div class="file-row" *ngFor="let image of images">



        <div class="file-left">
          <div class="file-icon">
            <i class="bi bi-file-earmark-fill" style="font-size:1.5rem;"></i>
          </div>

          <div class="file-meta">
            <div class="file-top">
              <span class="file-name">{{ image.file.name }}</span>
              <span class="file-size">{{ image.sizeText }}</span>
            </div>

            <div class="file-progress">
              <div class="bar"></div>
            </div>

            <div class="file-status">Archivo cargado</div>
          </div>
        </div>

        <button type="button" class="file-trash" (click)="removeImage(image)">
          <i class="bi bi-trash"></i>
        </button>
      </div>
    </div>

  </div>

  <!-- Footer buttons -->
  <div class="reject-footer">
    <button type="button" class="btn-outline w-120 btn-volver" (click)="close()">
      Volver
    </button>

    <button type="button" class="btn-primary w-120" [disabled]="isDisabled()" [class.disabled]="isDisabled()"
      (click)="confirmModal()">
      Rechazar
    </button>
  </div>
</div>

<!-- Modal interno confirmación/éxito -->
<ng-template #modalContent>
  <div class="container-exitoso" style="padding-left: 1rem">
    <button mat-icon-button class="close-icon close-button">
      <i class="bi bi-x-lg" (click)="closeConfirmModal()"></i>
    </button>

    <!-- ✅ SOLO ÉXITO -->
    <div>
      <div class="header-container title-container">
        <i class="bi bi-check-circle" style="color:#007a47; transform: scale(1.4); display:inline-block;"></i>
        <h6 class="text-title title">Rechazado</h6>
      </div>

      <div>
        <p style="text-align: center">El camión se rechazó exitosamente.</p>
      </div>

      <div class="buttons">
        <a href="javascript:void(0)" class="btn btn-primary btn-back btn-l-md" (click)="ok()">Aceptar</a>
      </div>
    </div>
  </div>
</ng-template>

